import { jsx as _jsx } from "react/jsx-runtime";
import { TreeItem2 as TreeItem } from '@mui/x-tree-view';
import { ObjectTree } from '../../../../v2/components/generic/ObjectTree/ObjectTreev2';
import { NavigationSkeleton } from '../../../common/NavigationSkeleton';
import { useRegionQuery } from '../../TreeDefinitions/Region';
const debug = process.env.REACT_APP_DEBUG && false;
export const AdminRegionTrees = ({ applicationData, transactionFunctions, contextCustomer, lastKey }) => {
    const key = `${lastKey}_Region`;
    const topLevelRegions = applicationData?.getApexNodes().filter((node) => node.type === 'Region') ?? [];
    const { objectTreeQueryPath: RegionQuery } = useRegionQuery();
    return RegionQuery ? (_jsx(TreeItem, { itemId: key, label: "Regions", children: contextCustomer !== undefined && applicationData !== undefined && (_jsx(ObjectTree, { nodeEdgeMapper: applicationData,
            queryPaths: RegionQuery,
            contextObjects: topLevelRegions,
            transactionFunctions,
            hideTopStep: false,
            maintree_rightclick: true,
            selectedNodeIds: [],
            expanded: [],
            orderByName: true,
            maxVisibleNodes: 10 }, key)) }, key)) : (_jsx(NavigationSkeleton, {}, key));
};
